import styled from "styled-components";

export const SendCodeStyle = styled.div`
    .sendMsg {
        width: 132px;
        margin-left: ${(props) => props.theme.space.margin}px;
    }
`